import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
import App from './App';
import {AppContextProvider} from "./services/AppContext";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
    window.document.getElementById('root') as HTMLElement
);

root.render(
    <QueryClientProvider client={queryClient}>
        <AppContextProvider>
            <App/>
        </AppContextProvider>
    </QueryClientProvider>
);